<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path opacity="0.5" d="M8 0.116853C10.1058 0.116852
      12.0852 0.936694 13.5742
      2.42577C15.0633 3.91484 15.8831 5.89415 15.8831 8C15.8831
      10.1059 15.0633 12.0852 13.5742 13.5742C12.0852
      15.0633 10.1059 15.8831 8 15.8831C5.89415 15.8831 3.91484
      15.0633 2.42577 13.5742C0.936694 12.0852 0.116851
      10.1059 0.116851 8C0.116851 5.89415 0.936693 3.91484 2.42576
      2.42577C3.91484 0.936695 5.89415 0.116853 8 0.116853ZM8
      14.8669C11.7865 14.8669 14.8669 11.7865 14.8669 8C14.8669
      4.21354 11.7865 1.13315 8 1.13315C4.21354 1.13315 1.13315
      4.21354 1.13315 8C1.13315 11.7865 4.21354 14.8669
      8 14.8669Z"
            fill="#0D7BC4"
            stroke="#0D7BC4"
            stroke-width="0.233703"/>
      <path d="M9.88315 8.30465L9.88314 8.30466L7.8539
      10.3338C7.68577 10.502 7.41315 10.5021 7.24506 10.3339L9.88315
      8.30465ZM9.88315 8.30465C9.96715 8.22064 10.0092 8.11031
      10.0092 8.00027C10.0092 7.89029 9.96722 7.78002 9.88321
      7.69597L9.88319 7.69595M9.88315 8.30465L9.88319
      7.69595M7.24506 9.7251C7.07698 9.89316 7.07697 10.1657 7.24502
      10.3338L7.2451 5.66674C7.07702 5.83484 7.07704 6.10739
      7.2451 6.27551L7.24511 6.27553L8.96993 8.00028L7.24506
      9.7251ZM7.24506 9.7251L7.31577 9.79581M7.24506 9.7251L7.24506
      9.7251L7.31577 9.79581M7.31577 9.79581L9.04064
      8.07099L7.31577 10.2631C7.18674 10.1341 7.18674 9.92483 7.31577
      9.79581ZM9.88319 7.69595L7.85393 5.66673C7.85393
      5.66673 7.85393 5.66673 7.85393 5.66673C7.6858 5.4986 7.41321
      5.49858 7.24511 5.66673L9.88319
      7.69595Z" fill="#0D7BC4" stroke="#0D7BC4" stroke-width="0.2"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" transform="translate(16 16) rotate(180)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'BBPIconArrows'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPIcons/BBPIconArrows.vue